// Initial-filter builders for <Report> / <CommonReport>.
//
// Declared once so the field name and the label are not spelled out at every call site
// (Architecture.md -> Reviewer-Judgment Concerns R2). Report.js matches an entry in the report's
// filterWhereInfoList on fieldName first and displayLabel second, so a filter has to carry both to
// survive a report whose definition names the column either way.

// OMTRANSACTIONHEADER.KEYSEQUENCE - the header's Record #, which is how a report is scoped to one
// order. Matches the Record # entry the OM header reports share
// (Argos.Core/Report/OM/TransactionHeaderFilters.cs).
export const RECORD_NUMBER_FIELD_NAME = "KEYSEQUENCE";
export const RECORD_NUMBER_DISPLAY_LABEL = "Record #";

/**
 * initialFilters scoping a report to a single record. Returns an empty list when there is no record
 * number, so the report opens unfiltered rather than filtered on a blank value.
 *
 * @param {number|string|null|undefined} recordNumber header Record # (KEYSEQUENCE)
 */
export const recordNumberFilter = (recordNumber) =>
    recordNumber
        ? [
              {
                  fieldName: RECORD_NUMBER_FIELD_NAME,
                  displayLabel: RECORD_NUMBER_DISPLAY_LABEL,
                  value: recordNumber,
              },
          ]
        : [];
